import { polyfill } from 'es6-promise';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { QuickScan } from "./components/QuickScan";

polyfill();


export const quickScan = (): void => {

    const quickscanContainer: HTMLElement | null = document.getElementById('zmp-js-quickscan');

    if (quickscanContainer !== null) {

        const apiUrl: string = quickscanContainer.getAttribute('data-apiUrl') as string;
        const type: string = quickscanContainer.getAttribute('data-type') as string;

        if (apiUrl !== null) {
            ReactDOM.render(
                <QuickScan apiUrl={apiUrl} type={type}/>,
                quickscanContainer,
            );
        }

    }

}
